import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  promotionsTabbedNav: {
    "& .tab-content": {
      [`@media (max-width:${breakpoints.lg}px)`]: {
        marginTop: "42px",
      },
    },
  },
  tabs: {
    borderColor: theme.tabs.borderColor,
    "& li": {
      "& button": {
        marginRight: "16px",
        "&.nav-link": {
          border: "none",
          borderColor: theme.tabs.borderColor,
          color: theme.tabs.color,
          fontWeight: "600",
          padding: "0px 4px 9px",
          "&.active": {
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          },
          "&:hover": {
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          },
        },
        "&:focus-visible": {
          boxShadow: "0px 0px 0px 4px " + colors.primary500Blue,
        },
      },
    },
  },
}));

export default styles;
